import generalSection from "../_section/section.class";
import {adminDDBankAccountUpload, userDDBankAccountUpload} from "./upload";
import ApplicationForm from "./ApplicationForm";
import DataForm from "./DataForm";

export class userDDBankAccountSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userDDBankAccountUpload);
        // Add missing date error

    }
}

export class adminDDBankAccountSection extends userDDBankAccountSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminDDBankAccountUpload);
        this.DataForm = DataForm
        this.ApplicationForm = ApplicationForm
        this.sortByDateProp('documentDate');
        this.activeUpload = this.uploads.find(u => u.allValuesAnswered && u.isVerifiable)
        this.setProblems( this.getProblems())
    }

    getProblems (){
        const problems =  this.problemsList.singleUploadUserProblems();
        return problems
    }

    getSectionSummary = () => {
        return [
            {
                name: this.personalTitle,
                tags:[{
                    name: 'Dated',
                    value: this.activeUpload?.values?.documentDate?.format('D MMM YYYY') || 'Not Provided'
                }]
            }
            ]
    }
}